var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg77(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 492,
    viewBox: "0 0 700 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 698,
    height: 490,
    rx: 24,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 146,
    width: 40,
    height: 301,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 271,
    width: 40,
    height: 176,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 215,
    width: 40,
    height: 232,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 238,
    width: 40,
    height: 209,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 185,
    width: 40,
    height: 262,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "#01C75B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 140,
    width: 40,
    height: 307,
    rx: 10,
    fill: "#808080"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 254,
    width: 40,
    height: 193,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 226,
    width: 40,
    height: 221,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 168,
    width: 40,
    height: 279,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 204,
    width: 40,
    height: 243,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.61 53V35.84H209.38C211.34 35.84 213.03 36.19 214.45 36.89C215.89 37.59 217 38.59 217.78 39.89C218.58 41.17 218.98 42.68 218.98 44.42C218.98 46.18 218.58 47.7 217.78 48.98C217 50.26 215.89 51.25 214.45 51.95C213.03 52.65 211.34 53 209.38 53H201.61ZM205.39 49.94H209.26C210.48 49.94 211.53 49.72 212.41 49.28C213.29 48.84 213.97 48.21 214.45 47.39C214.93 46.57 215.17 45.58 215.17 44.42C215.17 43.26 214.93 42.27 214.45 41.45C213.97 40.63 213.29 40.01 212.41 39.59C211.53 39.15 210.48 38.93 209.26 38.93H205.39V49.94ZM223.662 42.83H232.362V45.77H223.662V42.83ZM224.172 49.97H233.712V53H220.392V35.84H233.382V38.9H224.172V49.97ZM238.518 43.64H247.188V46.67H238.518V43.64ZM238.998 53H235.218V35.84H248.208V38.9H238.998V53ZM252.553 42.83H261.253V45.77H252.553V42.83ZM253.063 49.97H262.603V53H249.283V35.84H262.273V38.9H253.063V49.97ZM264.11 53V35.84H267.23L277.58 48.38H276.17V35.84H279.92V53H276.8L266.45 40.46H267.89V53H264.11ZM295.435 47.93C295.435 49.01 295.135 49.95 294.535 50.75C293.955 51.55 293.125 52.18 292.045 52.64C290.965 53.08 289.645 53.3 288.085 53.3C286.745 53.3 285.425 53.12 284.125 52.76C282.845 52.4 281.815 51.93 281.035 51.35L282.445 48.41C283.165 48.95 284.045 49.38 285.085 49.7C286.125 50.02 287.185 50.18 288.265 50.18C289.545 50.18 290.435 49.99 290.935 49.61C291.435 49.23 291.685 48.78 291.685 48.26C291.685 47.78 291.495 47.4 291.115 47.12C290.755 46.84 290.265 46.62 289.645 46.46C289.045 46.28 288.385 46.12 287.665 45.98C286.945 45.82 286.225 45.64 285.505 45.44C284.785 45.24 284.125 44.96 283.525 44.6C282.925 44.24 282.435 43.76 282.055 43.16C281.695 42.56 281.515 41.8 281.515 40.88C281.515 39.82 281.815 38.89 282.415 38.09C283.015 37.29 283.855 36.67 284.935 36.23C286.035 35.79 287.325 35.57 288.805 35.57C289.865 35.57 290.925 35.69 291.985 35.93C293.065 36.15 294.005 36.52 294.805 37.04L293.515 39.98C292.755 39.48 291.955 39.14 291.115 38.96C290.295 38.76 289.485 38.66 288.685 38.66C287.485 38.66 286.615 38.85 286.075 39.23C285.555 39.61 285.295 40.09 285.295 40.67C285.295 41.15 285.475 41.53 285.835 41.81C286.215 42.09 286.705 42.32 287.305 42.5C287.905 42.66 288.565 42.81 289.285 42.95C290.025 43.09 290.745 43.27 291.445 43.49C292.165 43.69 292.825 43.97 293.425 44.33C294.045 44.67 294.535 45.13 294.895 45.71C295.255 46.29 295.435 47.03 295.435 47.93ZM299.845 42.83H308.545V45.77H299.845V42.83ZM300.355 49.97H309.895V53H296.575V35.84H309.565V38.9H300.355V49.97ZM314.533 53L322.333 35.84H326.083L333.853 53H330.103L323.563 37.76H324.823L318.223 53H314.533ZM318.403 49.28L319.423 46.4H328.363L329.383 49.28H318.403ZM333.906 53V35.84H337.026L347.376 48.38H345.966V35.84H349.716V53H346.596L336.246 40.46H337.686V53H333.906ZM352.542 53V35.84H360.312C362.272 35.84 363.962 36.19 365.382 36.89C366.822 37.59 367.932 38.59 368.712 39.89C369.512 41.17 369.912 42.68 369.912 44.42C369.912 46.18 369.512 47.7 368.712 48.98C367.932 50.26 366.822 51.25 365.382 51.95C363.962 52.65 362.272 53 360.312 53H352.542ZM356.322 49.94H360.192C361.412 49.94 362.462 49.72 363.342 49.28C364.222 48.84 364.902 48.21 365.382 47.39C365.862 46.57 366.102 45.58 366.102 44.42C366.102 43.26 365.862 42.27 365.382 41.45C364.902 40.63 364.222 40.01 363.342 39.59C362.462 39.15 361.412 38.93 360.192 38.93H356.322V49.94ZM389.904 47.93C389.904 49.01 389.604 49.95 389.004 50.75C388.424 51.55 387.594 52.18 386.514 52.64C385.434 53.08 384.114 53.3 382.554 53.3C381.214 53.3 379.894 53.12 378.594 52.76C377.314 52.4 376.284 51.93 375.504 51.35L376.914 48.41C377.634 48.95 378.514 49.38 379.554 49.7C380.594 50.02 381.654 50.18 382.734 50.18C384.014 50.18 384.904 49.99 385.404 49.61C385.904 49.23 386.154 48.78 386.154 48.26C386.154 47.78 385.964 47.4 385.584 47.12C385.224 46.84 384.734 46.62 384.114 46.46C383.514 46.28 382.854 46.12 382.134 45.98C381.414 45.82 380.694 45.64 379.974 45.44C379.254 45.24 378.594 44.96 377.994 44.6C377.394 44.24 376.904 43.76 376.524 43.16C376.164 42.56 375.984 41.8 375.984 40.88C375.984 39.82 376.284 38.89 376.884 38.09C377.484 37.29 378.324 36.67 379.404 36.23C380.504 35.79 381.794 35.57 383.274 35.57C384.334 35.57 385.394 35.69 386.454 35.93C387.534 36.15 388.474 36.52 389.274 37.04L387.984 39.98C387.224 39.48 386.424 39.14 385.584 38.96C384.764 38.76 383.954 38.66 383.154 38.66C381.954 38.66 381.084 38.85 380.544 39.23C380.024 39.61 379.764 40.09 379.764 40.67C379.764 41.15 379.944 41.53 380.304 41.81C380.684 42.09 381.174 42.32 381.774 42.5C382.374 42.66 383.034 42.81 383.754 42.95C384.494 43.09 385.214 43.27 385.914 43.49C386.634 43.69 387.294 43.97 387.894 44.33C388.514 44.67 389.004 45.13 389.364 45.71C389.724 46.29 389.904 47.03 389.904 47.93ZM394.315 42.83H403.015V45.77H394.315V42.83ZM394.825 49.97H404.365V53H391.045V35.84H404.035V38.9H394.825V49.97ZM413.881 53.3C412.081 53.3 410.471 52.92 409.051 52.16C407.631 51.38 406.511 50.32 405.691 48.98C404.871 47.64 404.461 46.12 404.461 44.42C404.461 42.72 404.871 41.21 405.691 39.89C406.511 38.55 407.631 37.5 409.051 36.74C410.471 35.96 412.081 35.57 413.881 35.57C415.441 35.57 416.801 35.81 417.961 36.29C419.141 36.75 420.141 37.48 420.961 38.48L418.501 40.82C417.901 40.12 417.221 39.61 416.461 39.29C415.701 38.95 414.881 38.78 414.001 38.78C412.901 38.78 411.911 39.02 411.031 39.5C410.171 39.98 409.491 40.65 408.991 41.51C408.511 42.35 408.271 43.32 408.271 44.42C408.271 45.52 408.511 46.5 408.991 47.36C409.491 48.22 410.171 48.89 411.031 49.37C411.911 49.85 412.901 50.09 414.001 50.09C414.881 50.09 415.701 49.92 416.461 49.58C417.221 49.24 417.901 48.72 418.501 48.02L420.961 50.39C420.141 51.37 419.141 52.1 417.961 52.58C416.781 53.06 415.421 53.3 413.881 53.3ZM429.637 53.3C427.997 53.3 426.587 53 425.407 52.4C424.247 51.78 423.357 50.9 422.737 49.76C422.117 48.6 421.807 47.23 421.807 45.65V35.84H425.587V45.53C425.587 47.01 425.937 48.14 426.637 48.92C427.337 49.7 428.347 50.09 429.667 50.09C430.967 50.09 431.957 49.71 432.637 48.95C433.337 48.17 433.687 47.03 433.687 45.53V35.84H437.407V45.65C437.407 47.23 437.097 48.6 436.477 49.76C435.877 50.9 434.997 51.78 433.837 52.4C432.677 53 431.277 53.3 429.637 53.3ZM440.065 53V35.84H447.475C449.015 35.84 450.345 36.09 451.465 36.59C452.585 37.07 453.445 37.77 454.045 38.69C454.665 39.61 454.975 40.72 454.975 42.02C454.975 43.3 454.665 44.4 454.045 45.32C453.445 46.24 452.585 46.94 451.465 47.42C450.345 47.9 449.015 48.14 447.475 48.14H442.165L443.845 46.49V53H440.065ZM451.225 53L446.815 46.76H450.895L455.305 53H451.225ZM443.845 46.94L442.465 45.17H447.205C448.525 45.17 449.515 44.9 450.175 44.36C450.835 43.8 451.165 43.02 451.165 42.02C451.165 41.02 450.835 40.25 450.175 39.71C449.515 39.17 448.525 38.9 447.205 38.9H442.465L443.845 37.16V46.94ZM456.767 53V35.84H460.547V53H456.767ZM466.511 53V38.93H460.871V35.84H475.931V38.93H470.291V53H466.511ZM480.162 53V46.1L480.882 48.5L473.202 35.84H477.222L483.222 45.62H481.122L487.122 35.84H490.962L483.282 48.5L483.972 46.1V53H480.162Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg77);
export default __webpack_public_path__ + "static/media/77.8ab2e1f1c469fed50590f774711cb036.svg";
export { ForwardRef as ReactComponent };